import { useSnapshot } from 'valtio'
import cn from 'classnames'
import format from 'date-fns/format'
import { type ReactElement } from 'react'
import { parseISO } from 'date-fns'
import { recurringPaymentProxy } from '../../../../../shared/proxies/recurringPaymentProxy'
import { TableCell } from '../../../transactions/index/TransactionsTable/TransactionsRows/TableCell'
import OutlineButton from '../../../../../shared/components/ui/buttons/OutlineButton'
import {
  RpOccurrenceOriginalAmountCell
} from '../../index/components/RecurringPaymentsTable/components/RecurringPaymentsRows/components/AmountCell/RpOccurrenceOriginalAmountCell'
import { PRETTY_RP_OCCURRENCE_STATUS } from '../../../../../shared/types/GlobalRPOccurrenceStatuses'
import {
  determineTextColorClassRpOccurrence
} from '../../index/components/RecurringPaymentsTable/components/RecurringPaymentsRows/components/AmountCell/utils'
import { buildAppRpOccurrencePath } from '../../../../../pages/app/recurring-charges/[id]/rp-occurrence/[occurrenceId]'
import {
  RpOccurrenceCollectedAmountCell
} from '../../index/components/RecurringPaymentsTable/components/RecurringPaymentsRows/components/AmountCell/RpOccurrenceCollectedAmountCell'

export function RoOccurrencesRows (): ReactElement {
  const { rpOccurrences } = useSnapshot(recurringPaymentProxy)

  if (rpOccurrences?.length === 0) {
    return (
      <tr>
        <td colSpan={10}>
          <div className="text-center my-16 text-wpy-gray">
            No Results
          </div>
        </td>
      </tr>
    )
  }

  return (
    <>
      {rpOccurrences?.map((occurrence, i) => {
        const notLastRow = i !== (recurringPaymentProxy.rpOccurrences?.length - 1)
        const path = buildAppRpOccurrencePath({ occurrenceId: occurrence.id, paymentId: occurrence.recurringPaymentId })
        return (
          <tr
            key={occurrence.id}
            className={
              cn(
                'opacity-90 my-1 text-sm animate__animated animate__fadeIn',
                notLastRow && 'border-b border-gray-100'
              )
            }
          >
            <TableCell path={path}>
              {format(parseISO(occurrence.paymentDate), 'MMM d, y')}
            </TableCell>
            <TableCell path={path}>
              <RpOccurrenceOriginalAmountCell rpOccurrence={occurrence} />
            </TableCell>
            <TableCell path={path}>
              <RpOccurrenceCollectedAmountCell rpOccurrence={occurrence} />
            </TableCell>
            <TableCell path={path}>
              <div className={cn('px-2 py-1 border rounded-full text-left', determineTextColorClassRpOccurrence(occurrence))}>
                {PRETTY_RP_OCCURRENCE_STATUS[occurrence.status]}
              </div>
            </TableCell>

            <TableCell path={path}>
              <OutlineButton additionalClasses="px-12  py-1" clickFunction={() => {}} text="View Details" />
            </TableCell>

          </tr>
        )
      })}
    </>
  )
}
